import React from 'react';
import { t } from "@lingui/macro";
import styled from "styled-components";
import { withI18n } from '@lingui/react';
import { tabletBreakpoint, FHDBreakpoint1920px, smallScreenBreakpoint1064px } from "~styles/common";
import TransHTML from "../transHTML";
import InPageAnchor from '../InPageAnchor';

function HowItWorksPersonal({ i18n }) {
    return (
        <>
           <InPageAnchor id="HowToPay" />
            <Wrapper>
                <TopHeading>
                    <TransHTML id={t`personal.page.how_it_works.title`} />
                </TopHeading>

                <Row>
                    <Copy>
                        <Heading>
                            <TransHTML id={t`personal.page.how_it_works.noApp.subtitle`} />
                        </Heading>
                        <Paragraph>
                            <TransHTML id={t`personal.page.how_it_works.noApp.text`} />
                        </Paragraph>
                    </Copy>
                    <Image
                        alt='Wont to pay!'
                        src={i18n._(t`personal.page.how_it_works.noApp.image`)}
                    />
                </Row>

                <Row>
                    <Image
                        alt='Wont to pay!'
                        src={i18n._(t`personal.page.how_it_works.wont_to_pay.image`)}
                    />
                    <Copy>
                        <Heading>
                            <TransHTML id={t`personal.page.how_it_works.subtitle.search`} />
                        </Heading>
                        <Paragraph>
                            <TransHTML id={t`personal.page.how_it_works.text.search`} />
                        </Paragraph>
                    </Copy>
                </Row>

                <Row>
                    <Copy>
                        <Heading>
                            <TransHTML id={t`personal.page.how_it_works.subtitle.tipping`} />
                        </Heading>
                        <Paragraph>
                            <TransHTML id={t`personal.page.how_it_works.text.tipping`} />
                        </Paragraph>
                    </Copy>
                    <ImgBlockOrder
                        alt='Tipping'
                        src={i18n._(t`personal.page.how_it_works.tipping.image`)}
                    />
                </Row>

                <Row>
                    <Image
                        alt='Save time'
                        src={i18n._(t`personal.page.how_it_works.save_time.image`)}
                    />
                    <Copy>
                        <Heading>
                            <TransHTML id={t`personal.page.how_it_works.subtitle.save`} />
                        </Heading>
                        <Paragraph>
                            <TransHTML id={t`personal.page.how_it_works.text.save`} />
                        </Paragraph>
                    </Copy>
                </Row>
            </Wrapper>
        </>
    );
}

export default withI18n()(HowItWorksPersonal);

const Wrapper = styled.section`
    padding: 1.5rem 1rem;

    @media (min-width: ${tabletBreakpoint}) {
        padding: 3rem 1rem;
    }
`;

const Copy = styled.div`
    @media (min-width: ${tabletBreakpoint}) {
        max-width: 315px;
        padding-top: 10rem;
    }
`;

const Row = styled.div`
    display: flex;
    max-width: 990px;
    margin: 0 auto 2rem auto;
    flex-direction: column;
    align-items: flex-start;

    @media (min-width: ${tabletBreakpoint}) {
        justify-content: center;
        align-items: flex-start;
        flex-direction: unset;
        margin-bottom: 5rem;
    }
`;

const ImgBlockOrder = styled.img`
    width: 100%;
    background-position-x: center;
    height: 400px;
    object-fit: contain;
    margin-bottom: 2rem;
    order: -1;

   @media (min-width: ${tabletBreakpoint}) {
        background-position-x: right;
        width: 50%;
        height: 543px;
        margin-bottom: 0;
        order: 0;
    }

    @media (min-width: ${FHDBreakpoint1920px}) {
        height: 500px;
        transform: scale(1);
    }
`;

const Image = styled.img`
    width: 100%;
    background-position-x: center;
    height: 400px;
    object-fit: contain;
    margin-bottom: 2rem;

   @media (min-width: ${tabletBreakpoint}) {
        background-position-x: right;
        width: 50%;
        height: 543px;
        margin-bottom: 0;
    }

    @media (min-width: ${FHDBreakpoint1920px}) {
        height: 500px;
        transform: scale(1);
    }
`;

const TopHeading = styled.h2`
    text-align: center;
    font-size: 2rem;
    max-width: 400px;
    margin: 0 auto 2rem auto;
    color: #1A1A1A;
    font-weight: bold;

    @media (min-width: ${tabletBreakpoint}) {
        margin-bottom: 4rem;
    }

    @media (min-width: ${smallScreenBreakpoint1064px}) {
        font-size: 3rem;
        margin-bottom: 6rem;
        max-width: unset;
    }
`;

const Heading = styled.h3`
    line-height: 1.6;
    font-weight: 600;
    font-size: 1.5rem;

    @media (min-width: ${tabletBreakpoint}) {
        margin-bottom: 2rem;
    }

    @media (min-width: ${smallScreenBreakpoint1064px}) {
        max-width: 303px;
    }
`;

const Paragraph = styled.p`
    line-height: 2;
    font-size: 1rem;
    font-weight: 400;

    @media (min-width: ${smallScreenBreakpoint1064px}) {
        max-width: 265px;
    }
`;




